document.addEventListener('DOMContentLoaded', function () {
  const filterWrapper = document.querySelector('.blog-filter-wrapper');
  if (!filterWrapper) return;

  const blogUrl = filterWrapper.getAttribute('data-blog-url');
  const filterButton = filterWrapper.querySelector('.blog-filter-button');
  const filterMenu = filterWrapper.querySelector('.blog-filter-menu');
  const filterSelected = filterWrapper.querySelector('.blog-filter-selected');
  const gridContainer = document.getElementById('BlogArticlesGrid');
  const paginationContainer = document.getElementById('BlogPagination');

  if (!filterButton || !filterMenu || !gridContainer) return;

  // Toggle Dropdown
  filterButton.addEventListener('click', function (e) {
    e.stopPropagation();
    filterMenu.classList.toggle('show');
    filterButton.classList.toggle('active');
  });

  document.addEventListener('click', function (e) {
    if (!filterButton.contains(e.target) && !filterMenu.contains(e.target)) {
      filterMenu.classList.remove('show');
      filterButton.classList.remove('active');
    }
  });

  // Handle Filter Selection (AJAX)
  filterMenu.addEventListener('click', function (e) {
    const option = e.target.closest('.blog-filter-option');
    if (!option) return;

    const filterValue = option.getAttribute('data-filter');
    const filterText = option.textContent.trim();

    filterSelected.textContent = filterText;
    filterMenu.classList.remove('show');
    filterButton.classList.remove('active');

    let targetUrl = blogUrl;
    if (filterValue !== 'all') {
      targetUrl += '/tagged/' + filterValue;
    }

    fetchFilteredResults(targetUrl);
  });

  // Intercept Pagination Clicks to remain on the same page
  document.addEventListener('click', function (e) {
    const paginationLink = e.target.closest('#BlogPagination a');
    if (paginationLink) {
      e.preventDefault();
      fetchFilteredResults(paginationLink.href);
    }
  });

  function fetchFilteredResults(url) {
    // Add loading state
    gridContainer.style.opacity = '0.5';
    gridContainer.style.pointerEvents = 'none';

    // Add cache buster to ensure we get fresh data
    const cacheBuster = `ts=${Date.now()}`;
    const separator = url.includes('?') ? '&' : '?';
    const finalUrl = `${url}${separator}${cacheBuster}`;

    fetch(finalUrl, {
      cache: 'no-store', // Tell browser not to use cache
      headers: {
        'Pragma': 'no-cache',
        'Cache-Control': 'no-cache'
      }
    })
      .then(response => response.text())
      .then(html => {
        const parser = new DOMParser();
        const doc = parser.parseFromString(html, 'text/html');

        const newGrid = doc.getElementById('BlogArticlesGrid');
        const newPagination = doc.getElementById('BlogPagination');

        if (newGrid) {
          gridContainer.innerHTML = newGrid.innerHTML;
        } else {
          gridContainer.innerHTML = '<p class="center">No articles found in this category.</p>';
        }

        if (paginationContainer) {
          paginationContainer.innerHTML = newPagination ? newPagination.innerHTML : '';
        }

        gridContainer.style.opacity = '1';
        gridContainer.style.pointerEvents = 'all';

        // Scroll back to top of grid for better UX
        const headerOffset = 100;
        const elementPosition = gridContainer.getBoundingClientRect().top;
        const offsetPosition = elementPosition + window.pageYOffset - headerOffset;

        window.scrollTo({
          top: offsetPosition,
          behavior: 'smooth'
        });
      })
      .catch(error => {
        console.error('Filtering error:', error);
        gridContainer.style.opacity = '1';
        gridContainer.style.pointerEvents = 'all';
      });
  }
});
